module.exports = __webpack_public_path__ + "img/copyclipboard.36d18e94.svg";